import request from '@/utils/request';

// 登录
export function login(userAccount,password,captchaVerification){
  const data = {
    userAccount,
    password,
    params:captchaVerification
  };
  return request.post('/login',data);
}

// 登出
export function logoutSystem(token){
  if(!token || token.trim().length == 0){
    return;
  }
  let config  = {
    headers:{token}
  };
  return request.post('/logout',null,config);
}



// WEBPACK FOOTER //
// ./src/api/public.js